<agr-page-toolbar
  [pageTitle]="'app.within-cycle-performance' | translate"
  [emptyTitle]="'no-cycles-title' | translate"
  [emptyDescription]="'no-cycles-description' | translate"
  emptyImage="assets/images/flock-cycle.jpg"
  data-test="cycle-overview"
>
  <ng-container actions>
    <mat-slide-toggle
      [hideIcon]="true"
      data-test="cycle-overview__toggleDetailedOverview"
      color="primary"
      [checked]="isDetailedOverview"
      class="text--small spacing--padding-right"
      (change)="toggleDetailedOverview()"
      labelPosition="after"
    >
      {{ 'cycle-overview.detailedOverview' | translate }}
    </mat-slide-toggle>
  </ng-container>

  <app-within-cycle-performance
    *ngIf="isDetailedOverview; else simpleOverview"
  ></app-within-cycle-performance>

  <ng-template #simpleOverview>
    <app-within-cycle-performance-overview-simple> </app-within-cycle-performance-overview-simple>
  </ng-template>
</agr-page-toolbar>
